<template>
  <article
    class="schedule__card"
    :style="{ top: `${top}px`, height: `${itemHeight}px` }"
    js-anim="tableitem"
  >
    <div class="schedule__header">
      <time :datetime="data.start">{{ data.hours }}</time>
      <em v-show="!isMobile()">{{ data.hashtags }}</em>
    </div>

    <div class="schedule__content">

      <h4 class="schedule__title">{{ data.title }}</h4>

      <div
        class="schedule__description"
        v-html="data.description"
      >
        {{ data.description }}
      </div>

    </div>
  </article>
</template>

<script>
import { isMobile } from '@/scripts/utils';

export default {
  name: 'TimetableItem',

  props: {
    data: {
      type: Object,
      required: true,
    },

    starts: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      deltaH: 0,
      top: 0,
      itemHeight: 0,

      isMobile,
    };
  },

  mounted() {
    this.calcVars();
    this.calcItemHeight();
  },

  methods: {
    calcVars() {
      const halfHourPx = document.querySelector('.timeline__hour').getBoundingClientRect().height;

      this.deltaH = halfHourPx / 30;
      this.top = this.starts.indexOf(this.data.start) * (halfHourPx / 6);
    },

    calcItemHeight() {
      const time1 = this.data.end.split(':')
      const time2 = this.data.start.split(':')
      const duration = ((parseInt(time1[0]) * 60) + parseInt(time1[1])) - ((parseInt(time2[0]) * 60) + parseInt(time2[1]));

      this.itemHeight = duration * this.deltaH;
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule {
  &__card {
    display: block;
    width: calc(100% - 40px);

    background: #F0F0F1;
    transition: background 0.3s $global-ease;

    @at-root .pointerevents:not(.touchevents) &:hover,
    .no-pointerevents.no-touchevents &:hover {
      background: white;
      z-index: 30;
    }

    @at-root .pointerevents:not(.touchevents) [data-conference="amsterdam"] &:hover .schedule__header,
    .no-pointerevents.no-touchevents [data-conference="amsterdam"] &:hover .schedule__header {
      background: $color-pink;
    }
    @at-root .pointerevents:not(.touchevents) [data-conference="san-francisco"] &:hover .schedule__header,
    .no-pointerevents.no-touchevents [data-conference="san-francisco"] &:hover .schedule__header {
      background: $color-blue;
    }
    @at-root .pointerevents:not(.touchevents) [data-conference="new-york"] &:hover .schedule__header,
    .no-pointerevents.no-touchevents [data-conference="new-york"] &:hover .schedule__header {
      background: $color-azure;
    }
  }

  &__header {
    display: block;
    background: #9B9B9B;
    padding: 10px 20px;

    color: $color-white;

    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    transition: background 0.3s $global-ease;

    time {
      display: inline-block;
      font-weight: 700;
      margin: 0 5px 0 0;
    }
  }

  &__content {
    padding: 10px 20px;
  }

  &__title {
    font-size: 1rem;
    margin: 0 0 7.5px;
  }
}
</style>
